const hasModel = (model) =>
  Number.isFinite(Number(model?.height)) &&
  Number(model.height) > 0 &&
  typeof model?.size === 'string' &&
  Boolean(model.size.trim())

export default hasModel
